module.exports = __webpack_public_path__ + "img/other.7f52ce80.svg";